/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("eo", {
  Cut: "Eltran\u0109i",
  "Heading 5": "Titolo 5",
  "Header 2": "\u0108apo 2",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Via retumilo ne subtenas rektan aliron al bufro. Bonvolu antata\u016de uzi klavarajn kombinojn Ctrl+X/C/V.",
  "Heading 4": "Titolo 4",
  Div: "Div",
  "Heading 2": "Titolo 2",
  Paste: "Englui",
  Close: "Fermi",
  "Font Family": "Tipara familio",
  Pre: "Pre",
  "Align right": "Ordigu dekstren",
  "New document": "Nova dokumento",
  Blockquote: "Mar\u011denigo",
  "Numbered list": "Numera listo",
  "Heading 1": "Titolo 1",
  Headings: "Titoloj",
  "Increase indent": "Pliigu alineon",
  Formats: "Formatoj",
  Headers: "\u0108apoj",
  "Select all": "Elekti \u0109ion",
  "Header 3": "\u0108apo 3",
  Blocks: "Blokoj",
  Undo: "Malfari",
  Strikethrough: "Trastreki",
  "Bullet list": "Punkta listo",
  "Header 1": "\u0108apo 1",
  Superscript: "Superskribi",
  "Clear formatting": "Forigi formatigon",
  "Font Sizes": "Tiparaj grandoj",
  Subscript: "Malsuperskribi",
  "Header 6": "\u0108apo 6",
  Redo: "Refari",
  Paragraph: "Alineo",
  Ok: "Bone",
  Bold: "Dika",
  Code: "Kodo",
  Italic: "Oblikva",
  "Align center": "Ordigu centren",
  "Header 5": "\u0108apo 5",
  "Heading 6": "Titolo 6",
  "Heading 3": "Titolo 3",
  "Decrease indent": "Malpliigu alineon",
  "Header 4": "\u0108apo 4",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "La engluado nun okazas en simpla teksta re\u011dimo. La enhavo estos engluata kiel simpla teksto \u011dis anta\u016d vi for\u015daltos tiun \u0109i opcion.",
  Underline: "Substreki",
  Cancel: "Nuligi",
  Justify: "Ordigu la\u016dflanke",
  Inline: "Enlinie",
  Copy: "Kopii",
  "Align left": "Ordigu maldekstren",
  "Visual aids": "Videblaj helpiloj",
  "Lower Greek": "Minuskla greka",
  Square: "Kvadrato",
  Default: "Implicite",
  "Lower Alpha": "Minuskla alfabeta",
  Circle: "Cirklo",
  Disc: "Disko",
  "Upper Alpha": "Majuskla alfabeta",
  "Upper Roman": "Majuskla latina",
  "Lower Roman": "Minuskla latina",
  Name: "Nomo",
  Anchor: "Ankro",
  "You have unsaved changes are you sure you want to navigate away?":
    "Vi havas nekonservitajn \u015dan\u011dojn, \u0109u vi certe deziras eliri?",
  "Restore last draft": "Restarigu lastan malneton",
  "Special character": "Speciala karaktro",
  "Source code": "Fonta kodo",
  B: "B",
  R: "R",
  G: "G",
  Color: "Koloro",
  "Right to left": "Dekstro maldekstren",
  "Left to right": "Maldekstro dekstren",
  Emoticons: "Emociikonoj",
  Robots: "Robotoj",
  "Document properties": "Dokumentaj trajtoj",
  Title: "Titolo",
  Keywords: "\u015closilvortoj",
  Encoding: "Enkodigo",
  Description: "Priskribo",
  Author: "A\u016dtoro",
  Fullscreen: "Tutekrane",
  "Horizontal line": "Horizontala linio",
  "Horizontal space": "Horizontala spaco",
  "Insert/edit image": "Enmetu/redaktu bildon",
  General: "\u011cenerale",
  Advanced: "Por spertuloj",
  Source: "Fonto",
  Border: "Limo",
  "Constrain proportions": "Relativigu proporciojn",
  "Vertical space": "Vertikala spaco",
  "Image description": "Bilda priskribo",
  Style: "Stilo",
  Dimensions: "Dimensioj",
  "Insert image": "Enmetu bildon",
  "Zoom in": "Plilar\u011digu",
  Contrast: "Kontrasto",
  Back: "Reen",
  Gamma: "Gamo",
  "Flip horizontally": "Respegulu horizontale",
  Resize: "\u015can\u011du dimensiojn",
  Sharpen: "Akrigu",
  "Zoom out": "Malplilar\u011digu",
  "Image options": "Bildaj opcioj",
  Apply: "Apliku",
  Brightness: "Heleco",
  "Rotate clockwise": "Rotaciu la\u016d horlo\u011do",
  "Rotate counterclockwise": "Rotaciu kontra\u016d horlo\u011do",
  "Edit image": "Redaktu bildon",
  "Color levels": "Kolorniveloj",
  Crop: "Randtran\u0109u",
  Orientation: "Orientigo",
  "Flip vertically": "Respegulu vertikale",
  Invert: "Inversigu",
  "Insert date/time": "Enmetu daton/tempon",
  "Remove link": "Forigu ligilon",
  Url: "Urlo",
  "Text to display": "Montrata teksto",
  Anchors: "Ankroj",
  "Insert link": "Enmetu ligilon",
  "New window": "Nova fenestro",
  None: "Nenio",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "La enmetita URLo \u015dajnas esti ekstera ligilo. \u0108u vi deziras aldoni nepran prefikson http://?",
  Target: "Celo",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "La enmetita URLo \u015dajnas esti retadreso. \u0108u vi deziras aldoni prefikson mailto:?",
  "Insert/edit link": "Enmetu/redaktu ligilon",
  "Insert/edit video": "Enmetu/redaktu videon",
  Poster: "Afi\u015do",
  "Alternative source": "Alternativa fonto",
  "Paste your embed code below:": "Engluu vian internan kodon \u0109i-sube:",
  "Insert video": "Enmetu videon",
  Embed: "Enkonstruu",
  "Nonbreaking space": "Nerompebla spaco",
  "Page break": "Pa\u011da fino",
  "Paste as text": "Engluu kiel tekston",
  Preview: "Provrigardo",
  Print: "Presu",
  Save: "Konservi",
  "Could not find the specified string.":
    "Malsukceso trovi la indikitan sinsekvon",
  Replace: "Anstata\u016digi",
  Next: "Posta",
  "Whole words": "Tutaj vortoj",
  "Find and replace": "Trovi kaj anstata\u016digi",
  "Replace with": "Anstata\u016digi per",
  Find: "Trovi",
  "Replace all": "Anstata\u016digi\u0109ion",
  "Match case": "Sekvi usklecon",
  Prev: "Anta\u016da",
  Spellcheck: "Literumu",
  Finish: "Finu",
  "Ignore all": "Ignoru \u0109ion",
  Ignore: "Ignoru",
  "Add to Dictionary": "Aldonu al vortaro",
  "Insert row before": "Enmetu vicon anta\u016d",
  Rows: "Vicoj",
  Height: "Alto",
  "Paste row after": "Engluu vicon poste",
  Alignment: "Aligo",
  "Border color": "Lima koloro",
  "Column group": "Kolumna grupo",
  Row: "Vico",
  "Insert column before": "Enmetu kolumnon anta\u016d",
  "Split cell": "Disdividu \u0109elon",
  "Cell padding": "\u0108elmar\u011denoj",
  "Cell spacing": "\u0108elspacoj",
  "Row type": "Vica tipo",
  "Insert table": "Enmetu tabelon",
  Body: "Korpo",
  Caption: "Cita\u0135o",
  Footer: "Piedo",
  "Delete row": "Forigu vicon",
  "Paste row before": "Engluu vicon anta\u016d",
  Scope: "Amplekso",
  "Delete table": "Forigu tabelon",
  "H Align": "H aligo",
  Top: "Supro",
  "Header cell": "\u0108apa \u0109elo",
  Column: "Kolumno",
  "Row group": "Vica grupo",
  Cell: "\u0108elo",
  Middle: "Mezo",
  "Cell type": "\u0108ela tipo",
  "Copy row": "Kopiu vicon",
  "Row properties": "Vicaj ecoj",
  "Table properties": "Tabelaj ecoj",
  Bottom: "Subo",
  "V Align": "V aligo",
  Header: "\u0108apo",
  Right: "Dekstro",
  "Insert column after": "Enmetu kolumnon poste",
  Cols: "Kolumonoj",
  "Insert row after": "Enmetu vicon poste",
  Width: "Lar\u011do",
  "Cell properties": "\u0108elaj ecoj",
  Left: "Maldekstro",
  "Cut row": "Eltran\u0109u vicon",
  "Delete column": "Forigu kolumnon",
  Center: "Centro",
  "Merge cells": "Kunigu \u0109elojn",
  "Insert template": "Enmetu \u015dablonon",
  Templates: "\u015cablonoj",
  "Background color": "Fona koloro",
  "Custom...": "Propra...",
  "Custom color": "Propra koloro",
  "No color": "Neniu koloro",
  "Text color": "Teksta koloro",
  "Show blocks": "Montru blokojn",
  "Show invisible characters": "Montru nevideblajn karaktrojn",
  "Words: {0}": "Vortoj: {0}",
  Insert: "Enmeti",
  File: "Dokumento",
  Edit: "Redakti",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Ri\u0109teksta Areo. Premu ALT-F9 por menuo. Premu ALT-F10 por menuejo. Premu ALT-0 por helpo",
  Tools: "Iloj",
  View: "Vidi",
  Table: "Tabelo",
  Format: "Aspektigi",
});
